// rAF-throttle for scroll handlers: coalesces bursts of scroll events into one
// execution per animation frame so layout reads don't run hundreds of times per scroll.
function vThrottleRaf(fn) {
    var scheduled = false;
    return function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
            scheduled = false;
            fn();
        });
    };
}

// 2026-09-25: slick carousels no longer hold up or hijack a vertical swipe.
//
// slick binds touchstart/touchmove through jQuery, which registers blocking
// listeners, so on an iPhone every swipe that started on a carousel (the
// product gallery fills most of a product page's first screen) waited on the
// page's JavaScript before Safari would scroll. They are passive now and the
// page scrolls at once. What stops a sideways swipe moving the page is the
// touch-action: pan-y slick.css already puts on .slick-slider, not the
// preventDefault, so nothing is lost.
//
// slick also claimed a gesture as a swipe after 4px of sideways travel, so a
// thumb that wobbled before moving up grabbed the carousel and the page did
// not scroll. It now waits for 10px and leaves the gesture to the page unless
// it is more sideways than vertical, the same test the browser uses for pan-y.
// The patch goes on slick's prototype the first time slick is called, so it
// covers every carousel on the page, including ones started later.
(function ($) {
    if (!$ || !$.fn || !$.fn.slick) return;
    ['touchstart', 'touchmove'].forEach(function (type) {
        $.event.special[type] = {
            setup: function (_, ns, handle) {
                this.addEventListener(type, handle, { passive: true });
            }
        };
    });
    var slick = $.fn.slick;
    var patched = false;
    $.fn.slick = function () {
        var out = slick.apply(this, arguments);
        var inst = !patched && this[0] && this[0].slick;
        if (inst) {
            patched = true;
            var proto = Object.getPrototypeOf(inst);
            var swipeMove = proto.swipeMove;
            proto.swipeMove = function (e) {
                var t = e.originalEvent && e.originalEvent.touches;
                if (t && t.length === 1) {
                    // The listener is passive, so this could only log a warning.
                    e.preventDefault = function () {};
                    if (this.dragging && !this.swiping && !this.scrolling) {
                        var dx = Math.abs(t[0].pageX - this.touchObject.startX);
                        var dy = Math.abs(t[0].pageY - this.touchObject.startY);
                        if (dx < 10 && dy < 10) return false;
                        if (dy >= dx) { this.scrolling = true; return false; }
                        // Decided: a swipe. Set it here, or slick's own check
                        // sees >4px of vertical travel and calls it a scroll.
                        this.swiping = true;
                    }
                }
                return swipeMove.call(this, e);
            };
        }
        return out;
    };
})(window.jQuery);

(function ($) {
    'use strict';
    var slickConfig = {


        // Start Slick Slider


        '.gallery__items': {
            mobile: true,
            desktop: false,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
            }
        },
        '.features-product__items': {
            mobile: true,
            desktop: false,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
            }
        }

        // End Slick Slider


    };

    var breakpoint = 820;
    var resizeTimer;
    function initSlider(selector, settings) {
        var $slider = $(selector);
        if ($slider.length && !$slider.hasClass('slick-initialized')) {
            $slider.slick(settings);
        }
    }
    function destroySlider(selector) {
        var $slider = $(selector);
        if ($slider.length && $slider.hasClass('slick-initialized')) {
            $slider.slick('unslick');
        }
    }
    function handleSliders() {
        var windowWidth = $(window).width();
        var isMobile = windowWidth < breakpoint;
        $.each(slickConfig, function (selector, config) {
            if (isMobile && config.mobile) {
                initSlider(selector, config.settings);
            } else if (!isMobile && config.desktop) {
                initSlider(selector, config.settings);
            } else {
                destroySlider(selector);
            }
        });
    }
    $(document).ready(function () {
        handleSliders();
    });
    $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            handleSliders();
        }, 250);
    });

})(jQuery);


// Header Sticky
// ============================================
function headerSticky() {
    let lastScrollTop = 0;
    const header = document.querySelector('.header');
    if (!header) return;

    window.addEventListener('scroll', vThrottleRaf(function () {
        const currentScroll = window.scrollY;

        if (currentScroll > 100) {
            header.classList.add('header__inner_hove-active');
        } else {
            header.classList.remove('header__inner_hove-active');
        }

        if (currentScroll === 0) {
            header.style.transform = 'translateY(0)';
            lastScrollTop = currentScroll;
            return;
        }

        // 2026-09-18: the header used to flip on ANY direction change, so a
        // 1px wobble (or a tap that nudges the page) retracted or dropped the
        // nav. It now needs 10px of travel in one direction before it moves,
        // and lastScrollTop only advances when it does, so a slow drag still
        // adds up to a flip. Nathan's mobile spec, gap 3.
        if (Math.abs(currentScroll - lastScrollTop) < 10) return;

        if (currentScroll < lastScrollTop) {
            header.style.transform = 'translateY(0)';
        } else {
            header.style.transform = 'translateY(-160%)';
        }

        lastScrollTop = currentScroll;
    }), { passive: true });
}
headerSticky();


// Scroll Animation
// ============================================
const elements = document.querySelectorAll(".scroll-animation");
function checkScroll() {
    elements.forEach(el => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.85) {
            el.classList.add("visible");
        }
    });
}
window.addEventListener("scroll", vThrottleRaf(checkScroll), { passive: true });
checkScroll();




// Reveal Animation
// ============================================
// 2026-09-25: removed. singleScrollReveal() faded .reveal-group children up
// 40px, one by one, as they scrolled into view, and on every scroll frame it
// measured each group and queued another timer per child, even after they
// were all showing. Jackson: the page should not move at all when you scroll.
// The children now start in their final state (assets/style.css).



// Thumb Animation
// ============================================
const thumbItems = document.querySelectorAll(".thumb-animate");
function checkVisibility() {
    thumbItems.forEach(el => {
        const rect = el.getBoundingClientRect();
        const elementHeight = rect.height;
        const visibleHeight = Math.min(window.innerHeight, rect.bottom) - Math.max(0, rect.top);

        if (visibleHeight >= elementHeight * 0.4) {
            el.classList.add("in-view");
        }
    });
}
window.addEventListener("scroll", vThrottleRaf(checkVisibility), { passive: true });
checkVisibility();




// hero animation start

$(window).on('load', function () {
    $('.anim-slide-in-left').addClass('is-active');
});


// hero animation end


// hydration-insights Dropdown Menu
// ============================================

if ($(window).width() < 820) {
    $(".hydration-insights__title").click(function () {
        if (
            $(this).hasClass('active')) {
            $(this).removeClass("active");
            $(this).next(".hydration-insights__content").slideUp();
        } else {
            $(".hydration-insights__content").slideUp();
            $(".hydration-insights__title").removeClass("active");
            $(this).addClass("active");
            $(this).next(".hydration-insights__content").slideDown();
        }
    })
}




// science tab start


$('.science__tab-item').first().addClass('active');
$('.science__tab-content').hide().first().show();
$('.science__tab-item').on('click', function () {
    const tab = $(this).data('tab');
    $('.science__tab-item').removeClass('active');
    $(this).addClass('active');
    $('.science__tab-content').hide();
    $('.science__tab-content[data-tab="' + tab + '"]').fadeIn(200);
});

// science tab end


// ============================================
// Accordion 
// ============================================

$(".accordion__title.active")
    .next(".accordion__content")
    .show();
$(".accordion__title").on("click", function (e) {
    e.preventDefault();
    var $this = $(this);
    var $content = $this.next(".accordion__content");
    $(".accordion__content").stop(true, true);
    $(".accordion__title").not($this).removeClass("active");
    $(".accordion__content").not($content).slideUp(400);
    $this.toggleClass("active");
    $content.slideToggle(400);
});


// balance mobile tab start

if ($(window).width() < 820) {
    $(document).ready(function () {
        $(".balance__tab-items .tagline").on("click", function () {
            const type = $(this).data("type");
            $(".balance__tab-items .tagline").removeClass("active");
            $(this).addClass("active");
            $(".balance__tab-content-item").removeClass("active");
            $('.balance__tab-content-item[data-type="' + type + '"]').addClass("active");
        });
        $(".balance__tab-items .tagline[data-type='before']").trigger("click");
    });
}

// balance mobile tab end




// button hover move start



    function wrapButtonText() {
        $(".btn-secondary, .btn-primary").each(function () {
            let text = $(this).text().trim();
            if ($(this).find('.curb-top').length === 0) {
                $(this).empty();
                $(this).append(`
                    <div class="curb-top"></div>
                    <em>${text}</em>
                    <div class="curb-bot"></div>
                `);
            }
        });
        $(".btn-secondary, .btn-primary").on("mousemove", function (e) {
            let width = $(this).outerWidth();
            let offsetLeft = $(this).offset().left;
            let xPos = e.pageX - offsetLeft;
            if (xPos < 0) xPos = 0;
            if (xPos > width) xPos = width;
            let percentage = (xPos / width) * 100;
            $(this).find(".curb-top, .curb-bot").css("--position", percentage + "%");
        });
        $(".btn-secondary, .btn-primary").on("mouseleave", function () {
            $(this).find(".curb-top, .curb-bot").css("--position", "50%");
        });
    }
    wrapButtonText();

    

$(document).ready(function () {
    $(".hero__btn-science").on("mousemove", function (e) {
        let width = $(this).outerWidth();
        let offsetLeft = $(this).offset().left;
        let xPos = e.pageX - offsetLeft;
        if (xPos < 0) xPos = 0;
        if (xPos > width) xPos = width;
        let percentage = (xPos / width) * 100;
        $(this).css("--pos", percentage + "%");
    });
    $(".hero__btn-science").on("mouseleave", function () {
        $(this).css("--pos", "50%");
    });
});


$(document).ready(function () {
    $(".product-card").on("mousemove", function (e) {
        let width = $(this).outerWidth();
        let offsetLeft = $(this).offset().left;
        let xPos = e.pageX - offsetLeft;
        if (xPos < 0) xPos = 0;
        if (xPos > width) xPos = width;
        let percentage = (xPos / width) * 100;
        $(this).css("--pos", percentage + "%");
    });
    $(".product-card").on("mouseleave", function () {
        $(this).css("--pos", "50%");
    });
});


// button hover move end






// bottom-fixed-product start

$(document).ready(function () {
    var $bottomProduct = $('.bottom-fixed-product');
    var $hero = $('.hero');
    if (!$hero.length) return;
    function toggleBottomProduct() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();
        var heroTop = $hero.offset().top;
        var heroHeight = $hero.outerHeight();
        if (scrollTop + windowHeight > heroTop + (heroHeight * 0.2) &&
            scrollTop < heroTop + heroHeight) {
            $bottomProduct.addClass('is-hidden');
        } else {
            $bottomProduct.removeClass('is-hidden');
        }
    }
    toggleBottomProduct();
    window.addEventListener('scroll', vThrottleRaf(toggleBottomProduct), { passive: true });
    window.addEventListener('resize', vThrottleRaf(toggleBottomProduct));
});

// bottom-fixed-product end






$(".trust-badges__items").slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    variableWidth: true,
    arrows: false,
    pauseOnHover: false,
});



// single-product slider start

$('.single-product_big-items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    asNavFor: '.single-product__small-items',
});
$('.single-product__small-items').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.single-product_big-items',
    centerMode: false,
    focusOnSelect: true,
    arrows: false,
});


$('.single-product__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.single-product__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});
$('.single-product__right-arrow-mobile').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});


// single-product slider end



// Start Input Quantity Upgraded
$(document).ready(function () {
    $('.single-product__quantity-plus').on('click', function () {
        let $input = $(this).siblings('input');
        let currentVal = parseInt($input.val());
        if (!isNaN(currentVal)) {
            $input.val(currentVal + 1);
        }
    });
    $('.single-product__quantity-minus').on('click', function () {
        let $input = $(this).siblings('input');
        let currentVal = parseInt($input.val());
        if (!isNaN(currentVal) && currentVal > 1) {
            $input.val(currentVal - 1);
        }
    });
});
// End Input Quantity Upgraded



function handleLoading($btn, duration = 1200) {
    const $parent = $btn.parent();
    clearTimeout($parent.data("loadingTimeout"));
    $parent.addClass("loading");
    const timeoutId = setTimeout(function () {
        $parent.removeClass("loading");
    }, duration);
    $parent.data("loadingTimeout", timeoutId);
}
$(document).on("click", ".click-loading", function (e) {
    e.preventDefault();
    handleLoading($(this));
});



$(document).on("click", ".header__cart , .header__mobi-cart", function (e) {
    e.preventDefault();
    $("body").addClass("cart-drawer-open");
});

$(".cart-drawer__close , .overlay").on("click", function () {
    $("body").removeClass("cart-drawer-open");
});


// Start Border Button Shape Moving
$(document).ready(function () {
    $(".btn-border").css("--pos", "50%");
    $(".btn-border").on("mousemove", function (e) {
        let width = $(this).outerWidth();
        let offsetLeft = $(this).offset().left;
        let xPos = e.pageX - offsetLeft;
        if (xPos < 0) xPos = 0;
        if (xPos > width) xPos = width;
        let percentage = (xPos / width) * 100;
        percentage = Math.max(10, Math.min(90, percentage));
        $(this).css("--pos", percentage + "%");
    });
    $(".btn-border").on("mouseleave", function () {
        $(this).css("--pos", "50%");
    });
});
// End Border Button Shape Moving





if ($(window).width() < 820) {
    $('.system-breakdown__items').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
    });
}

$('.system-breakdown__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.system-breakdown__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});






// clock time
// function updateClock() {
//   const timeWrap = document.querySelector('.about-hero__video-time');
//   if (!timeWrap) return;

//   const spans = timeWrap.querySelectorAll('span');
//   const now = new Date();

//   spans[0].textContent = String(now.getHours()).padStart(2, '0');
//   spans[2].textContent = String(now.getMinutes()).padStart(2, '0');
//   spans[4].textContent = String(now.getSeconds()).padStart(2, '0');
// }

// updateClock();
// setInterval(updateClock, 1000);
// end clock time

// Start About Hero Video Time Dynamic

// $(document).ready(function () {
//     var $video = $('.about-hero__bg video')[0];
//     var $spans = $('.about-hero__video-time span');
//     function pad(n) {
//         return String(Math.floor(n)).padStart(2, '0');
//     }
//     function parseTime(seconds) {
//         return {
//             h: Math.floor(seconds / 3600),
//             m: Math.floor((seconds % 3600) / 60),
//             s: Math.floor(seconds % 60)
//         };
//     }
//     function updateTime(totalSeconds) {
//         var t = parseTime(totalSeconds);
//         $spans.eq(0).text(pad(t.h));
//         $spans.eq(2).text(pad(t.m));
//         $spans.eq(4).text(pad(t.s));
//     }
//     if ($video.readyState >= 1) {
//         updateTime($video.duration);
//     } else {
//         $($video).on('loadedmetadata', function () {
//             updateTime(this.duration);
//         });
//     }
//     $($video).on('timeupdate', function () {
//         updateTime(this.currentTime);
//     });
// });

// End About Hero Video Time Dynamic


// Start Realisation Slider
$('.realisation__content').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
});
var slickInstance = $('.realisation__content').slick('getSlick');
updateSliderNumber(slickInstance, 0);

$('.realisation__content').on('afterChange', function (event, slick, currentSlide) {
    updateSliderNumber(slick, currentSlide);
});
function updateSliderNumber(slick, currentSlide) {
    var total = slick.slideCount;
    var current = currentSlide + 1;
    $('.realisation__slider-number').html(
        '<span>' + String(current).padStart(2, '0') + '</span>' +
        '<span> / </span>' +
        '<span>' + String(total).padStart(2, '0') + '</span>'
    );
}
$('.realisation__arrow-left').click(function () {
    $(this).parent().parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.realisation__arrow-right').click(function () {
    $(this).parent().parent().parent().find('.slick-slider').slick('slickNext');
});
// End Realisation Slider




// // Star Page Story Video Height Active Class

// $('.page-story__video').on('mouseenter', function () {
//     $('.page-story__video-wrapper').addClass('active');
// });

// // End Page Story Video Height Active Class


// // Start Page Story Video Full Screen
// $(document).ready(function () {
//     $(".page-story__video-icon_resize").on("click", function () {
//         $(".page-story__video-wrapper").toggleClass("video-full-width");
//     });
// });
// // End Page Story Video Full Screen


// // Start Page Story Video On / Paused & Video  Icon Hide Show

// $(document).ready(function () {
//     const video = $(".page-story__video video").get(0);
//     $(".page-story__video-icon-off").hide();
//     $(".page-story__video-icon_play").on("click", function () {
//         if (!video) return;
//         if (video.paused) {
//             video.play();
//             $(".page-story__video-icon-on").show();
//             $(".page-story__video-icon-off").hide();
//         } else {
//             video.pause();
//             $(".page-story__video-icon-on").hide();
//             $(".page-story__video-icon-off").show();
//         }
//     });

// });

// // End Page Story Video On / Paused & Video  Icon Hide Show



// // Start Page Story Video Icon Scroll Positioning

// $(window).on("scroll", function () {
//     const $wrapper = $(".page-story__video-wrapper");
//     const $info = $(".page-story__video-info");
//     if (!$wrapper.hasClass("active") || $wrapper.hasClass("video-full-width")) {
//         $info.css({ position: "", top: "", left: "", width: "" });
//         return;
//     }
//     const rect = $wrapper[0].getBoundingClientRect();
//     const wrapperWidth = $wrapper.outerWidth();
//     if (rect.top <= 20 && rect.bottom > 70) {
//         $info.css({
//             position: "fixed",
//             top: "20px",
//             left: rect.left + "px",
//             width: wrapperWidth + "px",
//         });
//     } else {
//         $info.css({ position: "", top: "", left: "", width: "" });
//     }
// });

// // End Page Story Video Icon Scroll Positioning










$(document).ready(function () {
    $(".header__mobi-menu").on("click", function () {
        $("body").toggleClass("menu-drawer-open");
        if (
            $("body").hasClass("menu-drawer-open") &&
            $(window).scrollTop() > 50
        ) {
            $("body").addClass("menu-drawer-scroll");
        } else {
            $("body").removeClass("menu-drawer-scroll");
        }
        if ($("body").hasClass("menu-drawer-open")) {
            $(this).text("X CLOSE");
        } else {
            $(this).text("MENU");
        }
    });
    $(window).on("scroll", function () {
        if (
            $("body").hasClass("menu-drawer-open") &&
            $(window).scrollTop() > 50
        ) {
            $("body").addClass("menu-drawer-scroll");
        } else {
            $("body").removeClass("menu-drawer-scroll");
        }
    });
});

$('.menu-drawer__top li a').click(function(){
    $("body").removeClass("menu-drawer-open");
})



/* 2026-09-19: the collection hero follows the tabs. The banner
   (sections/main-collection-banner.liquid) already takes its heading and
   paragraph from whichever collection is being viewed, but only on a full
   page load. The tab handler below swapped .collection__products and
   nothing else, so landing on All products and pressing Creatine left
   "All products" and its paragraph sitting over a grid of creatine.

   The banner is now rendered for the clicked collection too, and only its
   .page-hero__content-text (the heading and the paragraph) is taken from it.
   So the copy is exactly what a direct load of that collection shows, and it
   is still written in one place: the collection's title and description in
   the Shopify admin. The tagline, background and bundle tile are the same on
   every collection and are left alone.

   It is fetched with ?section_id= by file name, which renders any section
   with its schema defaults. NOT ?sections=: that only renders sections that
   are already on the page (static ones by file name, template ones by their
   template--<id>__ id) and answers null for anything else. Checked against
   the live store, 19 Sep 2026.

   The hero changes in the same swap() as the grid, so the page switches as
   one. vuTabRequest drops the response to any tab that has since been
   superseded, so two quick taps cannot leave the lit tab, the hero and the
   grid disagreeing. */
var vuTabRequest = 0;

function vuSwapCollectionHero(html) {
    var live = document.querySelector('.page-hero__content-text');
    if (!live || !html) { return; }
    var incoming = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector('.page-hero__content-text');
    if (!incoming) { return; }
    live.innerHTML = incoming.innerHTML;

    /* The banner also uses the heading as the background image's alt text. */
    var heading = incoming.querySelector('h1');
    var bg = document.querySelector('.page-hero__bg img');
    if (heading && bg) { bg.alt = heading.textContent.trim(); }
}

/* 2026-09-05: :not(--build). This handler AJAX-swaps the collection tabs --
   it cancels the click and re-fetches the grid through the Section Rendering
   API instead. The "Build your System" item is in the same row and carries the
   same base class, but it is NOT a collection filter: it is a plain link out to
   the subscription builder. Once it became an <a> (it was a <button> opening a
   pop-up until today) it started matching this selector, so the click was
   cancelled and the tab went dead.

   The fetch was also fetching the builder's proxy URL with
   ?section_id=main-collection-product-grid, and the Section Rendering API does
   not support {% paginate %} -- which is where "Array 'collection.products' is
   not paginateable" came from. The tag is gone from the section now, but this
   guard is what stops a non-collection link being treated as a filter at all. */
$('.collection__filter-item:not(.collection__filter-item--build) a').click(function(e){
    e.preventDefault();
    var $clickedLink = $(this);
    var myCollection = $clickedLink.attr('href');
    var request = ++vuTabRequest;

    // Remove active class from all filter items
    $('.collection__filter-item a').removeClass('active');
    // Add active class to the clicked link
    $clickedLink.addClass('active');

    /* The hero copy for the same collection, fetched alongside the grid. A
       failed request resolves to '' and leaves the hero as it is. */
    var heroHtml = fetch(myCollection + "?section_id=main-collection-banner")
      .then(function (res) { return res.ok ? res.text() : ''; })
      .catch(function () { return ''; });
    
    /* 2026-09-06, three changes here.

       1. The incoming grid is parsed into a LIVE-document <div>, not with
          $(html). jQuery 3 parses into an inert document, where images never
          load -- so the old code swapped in a grid of empty <img> and every
          card showed its 337px #f4f4f4 placeholder until the packshots
          arrived. Parsing live, flipping the images to eager and waiting for
          them to decode means the swap happens with the pictures already
          there. Capped at 1.2s so a slow network never holds the tab.

       2. res.ok is checked and there is a .catch. jQuery's replaceWith() with
          an empty set REMOVES the target, so a failed fetch or a missed
          selector used to DELETE the product grid outright, with no way back
          but a reload.

       3. window.scrollBy({top: 2}) is gone. headerSticky() reads any downward
          movement as a scroll-down and slides the header off at -160%, so
          that stray 2px nudge retracted the nav on every tab click, even at
          the top of the page. It served no purpose. */
    fetch(myCollection + "?section_id=main-collection-product-grid")
      .then(function (res) {
        if (!res.ok) { throw new Error('HTTP ' + res.status); }
        return res.text();
      })
      .then(function (data) {
        if (request !== vuTabRequest) { return; }
        var parsed = document.createElement('div');
        parsed.innerHTML = data;
        var incoming = parsed.querySelector('.collection__products');
        if (!incoming) { return; }

        var imgs = incoming.querySelectorAll('img');
        var pending = imgs.length;
        var swapped = false;

        function swap() {
          if (swapped || request !== vuTabRequest) { return; }
          swapped = true;
          $('.collection__products').replaceWith(incoming);
          heroHtml.then(function (html) {
            if (request === vuTabRequest) { vuSwapCollectionHero(html); }
          });
        }

        if (!pending) { return swap(); }

        for (var i = 0; i < imgs.length; i++) {
          imgs[i].loading = 'eager';
          if (imgs[i].complete) {
            if (--pending <= 0) { swap(); }
            continue;
          }
          var done = function () { if (--pending <= 0) { swap(); } };
          imgs[i].addEventListener('load', done, { once: true });
          imgs[i].addEventListener('error', done, { once: true });
        }
        setTimeout(swap, 1200);
      })
      .catch(function () {
        /* Leave the grid that is on screen alone. */
      });
});



document.addEventListener('click', function (e) {
  const trigger = e.target.closest('.bundle__btn-wrap a, .value-bundle__btn a');

  if (!trigger) return;

  const href = trigger.getAttribute('href');
  if (!href) return;

  const collectionWrapper = document.querySelector('.collection__wrapper');

  if (collectionWrapper) {
    function normalizePath(h) {
      try {
        return new URL(h, window.location.origin).pathname.replace(/\/$/, '');
      } catch (_) {
        return h.split('?')[0].split('#')[0].replace(/\/$/, '');
      }
    }

    const targetPath = normalizePath(href);
    let matchingTab = null;

    collectionWrapper.querySelectorAll('.collection__filter-item a').forEach(function (tab) {
      const tabHref = tab.getAttribute('href');
      if (tabHref && normalizePath(tabHref) === targetPath) {
        matchingTab = tab;
      }
    });

    if (matchingTab) {
      e.preventDefault();
      matchingTab.click();

      setTimeout(function () {
        collectionWrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);

      return;
    }
  }

  // If href is a same-page anchor with no matching tab, scroll to it.
  // A bare "#" (the bundle ADD TO CART buttons, which add via their own
  // onclick) is not a selector, so skip it rather than throw.
  if (href.startsWith('#') && href.length > 1) {
    let targetSection = null;
    try {
      targetSection = document.querySelector(href);
    } catch (_) {}

    if (targetSection) {
      e.preventDefault();
      setTimeout(function () {
        targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    }
  }

  // Otherwise let the browser navigate normally
});








// About-page hero clock.
//
// 2026-08-25 (performance): the interval is now started only when the clock
// is actually on the page. It used to be unconditional, so every page on the
// site woke the main thread once a second forever to call querySelectorAll
// and return immediately. It is small per tick, but it is a timer that never
// stops, it keeps the CPU out of idle, and on mobile that is battery spent
// on nothing. The element only exists in sections/about-hero.liquid.
(function () {
  const spans = document.querySelectorAll('.about-hero__video-time span');
  if (spans.length < 5) return;

  let seconds = 1;

  function updateTimer() {
    const hrs = String(Math.floor(seconds / 3600)).padStart(2, '0');
    const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
    const secs = String(seconds % 60).padStart(2, '0');

    spans[0].textContent = hrs;
    spans[2].textContent = mins;
    spans[4].textContent = secs;

    seconds++;
  }

  updateTimer();
  setInterval(updateTimer, 1000);
})();



// Cross-page anchor scroll
// ============================================
// An inline script in layout/theme.liquid captures the URL hash on page load,
// stores it in window.__deferredAnchorHash, and strips it from the URL so the
// browser doesn't perform its own premature jump before the page has rendered.
//
// This handler waits for the page's load event (all resources fetched) and then
// waits ANCHOR_SCROLL_DELAY_MS before scrolling. The target position is
// intentionally measured INSIDE the timeout callback - after the delay - so
// that lazy-loaded images, Shopify app blocks, and dynamic sections have had
// time to inject content and shift the layout before we calculate the offset.

var ANCHOR_SCROLL_DELAY_MS    = 500; // ms after load before scrolling
var ANCHOR_SCROLL_EXTRA_PADDING = 20; // px clearance below the fixed header

(function () {
  var hash = window.__deferredAnchorHash;
  if (!hash) return;

  var hasScrolled = false;

  function performSmoothScroll() {
    if (hasScrolled) return;
    hasScrolled = true;

    // Defer measurement to the next paint frame so any synchronous layout work
    // triggered by late-loading content is committed before we read positions.
    requestAnimationFrame(function () {
      var target = null;
      try {
        target = document.querySelector(hash);
      } catch (err) {
        return;
      }

      // Restore the hash in the URL without triggering a native scroll jump.
      try {
        history.replaceState(null, '', window.location.pathname + window.location.search + hash);
      } catch (e) {}

      if (!target) return;

      // Account for the fixed header so the section isn't hidden beneath it.
      var header = document.querySelector('.header');
      var headerClearance = header ? (header.offsetHeight + 14) : 0;

      // Position calculated here, after ANCHOR_SCROLL_DELAY_MS has elapsed.
      var targetTop = window.pageYOffset + target.getBoundingClientRect().top
                      - headerClearance - ANCHOR_SCROLL_EXTRA_PADDING;

      window.scrollTo({ top: Math.max(0, targetTop), behavior: 'smooth' });
    });
  }

  // scheduleAfterLoad starts the delay countdown. It is called only after the
  // load event so all resources have been fetched before the timer begins.
  // { once: true } ensures the listener cannot fire more than once.
  function scheduleAfterLoad() {
    setTimeout(performSmoothScroll, ANCHOR_SCROLL_DELAY_MS);
  }

  if (document.readyState === 'complete') {
    // load has already fired; begin the delay immediately.
    scheduleAfterLoad();
  } else {
    window.addEventListener('load', scheduleAfterLoad, { once: true });
  }
})();